import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, SxProps, Theme, useTheme } from '@mui/material';
import { HEADER } from 'src/config-global';
import { useStores } from 'src/models';
import { isMobile } from 'src/utils/common';

import Header from './OsfcHeader';

export type OsfcLayoutContext = {
  setCustomLayoutStyle: React.Dispatch<React.SetStateAction<SxProps<Theme> | null>>;
};
// ----------------------------------------------------------------------
export default function OsfcLayout() {
  const theme = useTheme();
  const { commonCodeStore, permissionStore } = useStores();
  const [customLayoutStyle, setCustomLayoutStyle] = useState<SxProps<Theme> | null>(null);
  useEffect(() => {
    commonCodeStore.getsCommon();
    commonCodeStore.getsDynamic();
    permissionStore.getEmpPosList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box
        minWidth={isMobile() ? 'auto' : 900}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 1,
        }}
      >
        <Header />
        <Box
          id="osfc-layout"
          component="main"
          sx={{
            flex: 1,
            p: 2,
            pt: {
              xs: HEADER.H_MOBILE + 'px',
              md: HEADER.H_MAIN_DESKTOP + 'px',
            },
            background: theme.palette.background.neutral,
            position: 'relative',
            overflow: 'auto',
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),

            scrollbarWidth: 'thin',
            scrollbarColor: `${theme.palette.divider} ${theme.palette.background.neutral}`,
            '&::-webkit-scrollbar': { width: 8, height: 8 },
            ...customLayoutStyle,
          }}
        >
          <Outlet context={{ setCustomLayoutStyle }} />
          {/* Drawer Portal  */}
          <div id="drawer-root" />
        </Box>
      </Box>
    </>
  );
}
